// Data for info- and help bubbles
export const bubbleInfo = {
  // ### Form 1
  // Left
  form1_1_l: {
    title: "Vinkki",
    content: [
      "Tekijän löytäminen on helpompaa kun tiedät mitä tarvitset.",
      "Virherekrytointi on suurin vältettävissä oleva menoerä.",
    ],
  },
  form1_3_l: {
    title: "Vinkki",
    content: [
      "Vastavalmistunut tai vastaava on aluksi halvempi palkattava, tosin perehdytys vie alkuun siivun tuottavuudesta.",
      "Kokenut osaaja taas voi tuoda yritykselle nopeammin suurempia tuloja, mutta on kalliimpi palkattava.",
    ],
  },
  form1_2_l: {
    title: "Vinkki",
    content: [
      "Varaa rekrytointiin tarpeeksi aikaa.",
      "Pidä aikataulusta kiinni.",
      "Yleensä pienyrittäjän rekrytointiin kuluu aikaa n. kuukausi, josta työaikaa on n. 2-5 kokonaista työpäivää.",
    ],
  },

  // Right
  form1_1_r: {
    title: "Ohje",
    content: "Onko täytettävä tehtävä kokonaan uusi tai jo olemassa oleva?",
  },
  form1_2_r: {
    title: "Ohje",
    content: [
      "Mieti eri vaiheet ja kuka vastaa mistäkin vaiheesta.",
      "Voit kopioida esimerkkivastauksen itsellesi.",
    ],
  },
  form1_3_r: {
    title: "Ohje",
    content: [
      "Voit kopioida esimerkkivastauksen itsellesi.",
      "Linkin takaa löydät palkkalaskurin, jolla pystyt arvioimaan palkkakuluja.",
    ],
    link: ["Palkkalaskuri", "https://www.palkka.fi/palkkalaskuri/Index.htm"],
  },

  // ### Form 2
  // Left
  form2_1_l: {
    title: "Vinkki",
    content: [
      "Olethan muistanut jakaa ilmoitustasi myös sosiaalisessa mediassa.",
      "- Facebook",
      "- Instagram",
      "- Twitter",
    ],
  },
  form2_2_l: {
    title: "Vinkki",
    content: "Anna tehtävänimikkeeksi mahdollisimman selkeä ja kuvaava nimi.",
  },
  form2_3_l: {
    title: "Vinkki",
    content: [
      "Esittele yrityksesi toimintaa lyhyesti. Tiivistä asiat jotka saattavat kiinnostaa hakijoitasi.",
      "Kerro mitä yrityksesi tarjoaa hakijalle.",
      "Älä jaarittele, yritä pitää tekstilohkot lyhyinä.",
    ],
  },
  form2_4_l: {
    title: "Vinkki",
    content: [
      "Anna mahdollisimman selkeä kuvaus työn sisällöstä.",
      "Älä jaarittele, yritä pitää tekstilohkot lyhyinä.",
    ],
  },
  form2_5_l: {
    title: "Vinkki",
    content: [
      "Kuvalliset ilmoitukset saavat enemmän huomiota.",
      "Valitse sellainen kuva joka vahvistaa yrityskuvaasi.",
      "Videon tekeminen kannattaa, jos sinulla on siihen resursseja.",
    ],
  },

  // Right
  form2_1_r: {
    title: "Ohje",
    content:
      "Valitsemalla toisen sijaintivaihtoehdon, saat auki tarkentavia kenttiä.",
  },
  form2_2_r: {
    title: "Ohje",
    content: [
      "Kerro, mitä odotat työnhakijalta",
      "- osaaminen",
      "- työkokemus",
      "- koulutus",
      "- muut vaatimukset",
      "Erittele mitä vaadit ja mitä katsot eduksi.",
    ],
  },
  form2_3_r: {
    title: "Ohje",
    content: "Mistä mihin asti ilmoituksesi on esillä.",
  },
  form2_4_r: {
    title: "Ohje",
    content: "Duunitori: videon resoluutio.",
  },

  // ## Form 3
  // Left
  form3_1_l: {
    title: "Vinkki",
    content: "Yrityskuvan kannalta on hyvä vastata kaikille hakijoille.",
  },
  form3_2_l: {
    title: "Vinkki",
    content: [
      "Yrityskuvan kannalta on kannattavaa luoda hyvä hakijakokemus.",
      "- Vastaa kaikille hakijoille mahdollisimmnan nopeasti",
      "- Ole täsmällinen",
      "- Arvosta hakemuksia",
      "- Ole kohtelias",
    ],
  },

  // Right
  form3_1_r: {
    title: "Ohje",
    content: [
      "Varmista, että sinulla on aikaa hakijoiden yhteydenotoille.",
      "Anna mahdollisimman joustava aikatauluhaarukka, koska olet tavoitettavissa.",
      "Ja huolehdi, että pidät siitä myös kiinni.",
    ],
  },
  form3_2_r: {
    title: "Ohje",
    content: [
      "Kerro haastateltavalle kenet hän tapaa, missä ja koska.",
      "Kerro myös mitä hänen tulee ottaa mukaan haastatteluun.",
      "esim. todistukset",
    ],
  },

  // ## Form 4
  // Left
  form4_1_l: {
    title: "Vinkki",
    content:
      "Päätä tärkeimmät kysymykset, jotka tulee kysyttyä jokaiselta, vaikka itse haastattelut kulkisivat eri tavoilla.",
  },

  // Right
  form4_1_r: {
    title: "Ohje",
    content: [
      "Kehitä kysymyksiä, jotka luovat keskustelua.",
      "Vältä kyllä  tai ei vastauksia",
    ],
  },

  // ## Form 5
  // Left
  form5_1_l: {
    title: "Vinkki",
    content:
      "Sopimuspohjana voit käyttää vaikka seuraavaa työsuojelu.fi -palvelusta löytyvää pohjaa.",
    link: [
      "Sopimuslomake",
      "https://www.tyosuojelu.fi/documents/14660/338901/Ty%C3%B6sopimuslomake/20ded5b7-fd41-4f9a-b5b2-6418288f860c",
    ],
  },

  form5_1_r: {
    title: "",
    content: "",
  },

  // ## Form 6
  // Left
  form6_1_l: {
    title: "Vinkki",
    content: "Lisää tietoa työturvallisuuslaista.",
    link: ["Työturvallisuus", "https://www.tyoturvallisuus.eu/"],
  },
  form6_2_l: {
    title: "Vinkki",
    content: [
      "Perehdytyskansio on infopaketti yrityksesi uudelle työntekijälle",
      "Perehdytyskansion pohjan löydät täältä:",
    ],
    link: ["Perehdytyspohja", "https://www.perehdytysopas.fi/"],
  },

  // Right
  form6_1_r: {
    title: "Ohje",
    content: "Mieti, kuka vastaa perehdytyksestä.",
  },

  form6_2_r: {
    title: "Ohje",
    content: "Perehdytys on työturvallisuuslain nojalla pakollinen toteuttaa",
  },
};
